var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var cardsPagination = {};
var PAGE_TRANSITION_EXIT_MS = 240;
var PAGE_TRANSITION_ENTER_MS = 340;

function ensureStream(ctrl, key, initialValue) {
  if (typeof ctrl[key] !== 'function') {
    ctrl[key] = prop(initialValue);
  }
}

function readValue(value, fallback) {
  if (typeof value === 'function') return value();
  return value == null ? fallback : value;
}

function ensureInputState(ctrl, vnode) {
  var attrs = vnode && vnode.attrs ? vnode.attrs : {};
  ctrl.url = attrs.url;
  ctrl.recordsToShow = attrs.recordsToShow;
  ctrl.parameterFieldName = attrs.parameterFieldName;
  ctrl.onlyDirectEquipment = attrs.onlyDirectEquipment;

  if (typeof attrs.searchValue === 'function') {
    ctrl.searchValue = attrs.searchValue;
  } else {
    ensureStream(ctrl, 'searchValue', attrs.searchValue || '');
  }

  if (typeof attrs.locationRid === 'function') {
    ctrl.locationRid = attrs.locationRid;
  } else {
    ensureStream(ctrl, 'locationRid', attrs.locationRid || null);
  }

  if (typeof attrs.preferredNumberOfRowsValue === 'function') {
    ctrl.preferredNumberOfRowsValue = attrs.preferredNumberOfRowsValue;
  } else {
    ensureStream(ctrl, 'preferredNumberOfRowsValue', attrs.preferredNumberOfRowsValue || 1);
  }

  if (typeof attrs.selectedPage === 'function') {
    ctrl.selectedPage = attrs.selectedPage;
  } else {
    ensureStream(ctrl, 'selectedPage', attrs.selectedPage || 1);
  }

  if (typeof attrs.lastPage === 'function') {
    ctrl.lastPage = attrs.lastPage;
  } else {
    ensureStream(ctrl, 'lastPage', Boolean(attrs.lastPage));
  }

  ensureStream(ctrl, 'numberOfPages', 1);
}

function ensureAnimationState(ctrl) {
  ensureStream(ctrl, 'pageTransitionToken', 0);
  ensureStream(ctrl, 'pageTransitionDirection', '');
  ensureStream(ctrl, 'pageTransitionPhase', 'idle');
  ensureStream(ctrl, 'isPaging', false);

  if (typeof ctrl.beginPageTransition !== 'function') {
    ctrl.beginPageTransition = function (direction) {
      if (!direction) return;
      ctrl.pageTransitionDirection(direction);
      ctrl.pageTransitionPhase('exiting');
      if (ctrl.pageTransitionTimer) {
        clearTimeout(ctrl.pageTransitionTimer);
        ctrl.pageTransitionTimer = null;
      }
    };
  }

  if (typeof ctrl.completePageTransition !== 'function') {
    ctrl.completePageTransition = function (direction) {
      if (!direction) {
        ctrl.pageTransitionDirection('');
        ctrl.pageTransitionPhase('idle');
        if (ctrl.pageTransitionTimer) {
          clearTimeout(ctrl.pageTransitionTimer);
          ctrl.pageTransitionTimer = null;
        }
        return;
      }
      ctrl.pageTransitionDirection(direction);
      ctrl.pageTransitionPhase('entering');
      ctrl.pageTransitionToken(ctrl.pageTransitionToken() + 1);
      if (ctrl.pageTransitionTimer) {
        clearTimeout(ctrl.pageTransitionTimer);
      }
      ctrl.pageTransitionTimer = setTimeout(function () {
        ctrl.pageTransitionPhase('idle');
        ctrl.pageTransitionDirection('');
        ctrl.pageTransitionTimer = null;
        m.redraw();
      }, PAGE_TRANSITION_ENTER_MS);
    };
  }
}

cardsPagination.oninit = function (vnode) {
  var ctrl = this;
  ensureInputState(ctrl, vnode);
  ensureAnimationState(ctrl);

  ctrl.init = function(data){
    ctrl.originalData = JSON.parse(JSON.stringify(data))
    ctrl.data = data;
    ctrl.data.splice(1);
    ctrl.selectedPage(1);
    ctrl.pageTransitionDirection('');
    ctrl.pageTransitionPhase('idle');
    ctrl.numberOfPages = prop(Math.ceil(ctrl.originalData.length / ctrl.preferredNumberOfRowsValue()));
    if(ctrl.numberOfPages() > 1) ctrl.lastPage(false);
    var newViewArray = ctrl.originalData.slice(0, ctrl.preferredNumberOfRowsValue());
    ctrl.data.length = 0;
    ctrl.data.push(...newViewArray);

    ctrl.firstPage = function () {
      ctrl.selectedPage(1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue(), (((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue()+ctrl.preferredNumberOfRowsValue()-1)+1)));
      ctrl.lastPage(false);
      ctrl.request((ctrl.selectedPage()-1));
    }  
    ctrl.previusPage = function () {
      if (ctrl.isPaging()) return;
      ctrl.selectedPage(ctrl.selectedPage() - 1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue(), (((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue()+ctrl.preferredNumberOfRowsValue()-1)+1)));
      ctrl.lastPage(false);
      ctrl.request((ctrl.selectedPage()-1), 'backward');
    }
    ctrl.nextPage = function () {
      if (ctrl.isPaging()) return;
      ctrl.selectedPage(ctrl.selectedPage() + 1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue(), (((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue()+ctrl.preferredNumberOfRowsValue()-1)+1)));
      if(ctrl.selectedPage() == ctrl.numberOfPages()) ctrl.lastPage(true);
      ctrl.request((ctrl.selectedPage()-1), 'forward');
    }
  }
  ctrl.init(vnode.attrs.data);

  ctrl.request = function(pageNumber, direction){
    let parameters = {}
    var requestedAt = Date.now();
    parameters[ctrl.parameterFieldName] = pageNumber;
    parameters['search'] = ctrl.searchValue();
    parameters['onlyDirectEquipment'] = ctrl.onlyDirectEquipment;
    parameters['preferredNumberOfRowsValue'] = ctrl.preferredNumberOfRowsValue();
    parameters['locationRid'] = ctrl.locationRid();
    ctrl.beginPageTransition(direction);
    ctrl.isPaging(true);
    loaders.requestWithLoader({
      url: ctrl.url,
      params: parameters,
      method: 'GET',
      background: true
    })
    .then( data => {
      var waitMs = Math.max(0, PAGE_TRANSITION_EXIT_MS - (Date.now() - requestedAt));
      setTimeout(function () {
        ctrl.recordsToShow(data);
        ctrl.completePageTransition(direction);
        ctrl.isPaging(false);
        m.redraw();
      }, waitMs);
    })
    .catch(function (err) {
      ctrl.isPaging(false);
      ctrl.completePageTransition(null);
      throw err;
    })

  }
}

cardsPagination.onupdate = function(vnode){
  var ctrl = this;
  ensureInputState(ctrl, vnode);
  ensureAnimationState(ctrl);
  if(ctrl.preferredNumberOfRowsValue() != readValue(vnode.attrs.preferredNumberOfRowsValue, 1) || vnode.attrs.url != ctrl.url) {
    ensureInputState(ctrl, vnode);
    ctrl.init(vnode.attrs.data);
    ctrl.firstPage();
  }
}

cardsPagination.view = function(vnode) {
  var ctrl = this;
  ensureInputState(ctrl, vnode);
  ensureAnimationState(ctrl);
  var transitionDirection = ctrl.pageTransitionDirection();
  var transitionPhase = ctrl.pageTransitionPhase();
  var stripClass = 'flex justify-between w-100 alarm-card-page-strip';
  var viewportClass = 'alarm-card-page-viewport';

  if (transitionDirection && transitionPhase === 'exiting') {
    stripClass += ' alarm-card-page-strip--exit-' + transitionDirection;
  } else if (transitionDirection && transitionPhase === 'entering') {
    stripClass += ' alarm-card-page-strip--enter-' + transitionDirection;
  }
  if (transitionPhase === 'exiting' || transitionPhase === 'entering') {
    viewportClass += ' alarm-card-page-viewport--animating';
  }
  
  return m('div',[
    m('div.flex.justify-between.tr.mb2',[
      m('div.f2',`Event Reports`),
      m('div',`Page ${ctrl.selectedPage()} of ${ctrl.numberOfPages()}`),
    ]),
    m('div.flex.justify-between.items-stretch', [
      m(`div.ba.bw1${ctrl.selectedPage() == 1 ? '.dn' : '.flex.items-center'}${ctrl.isPaging() ? '.o-50' : ''}`, {
        onclick: function(e){
          if(ctrl.selectedPage()!=1 && !ctrl.isPaging()){
            ctrl.previusPage()
          }
        }
      }, [
        m('i.ion-ios-arrow-back.blue.f3.ph1')
      ]
      ),
      m('div', { class: viewportClass }, [
        m('div', {
          key: 'page-layer-' + ctrl.pageTransitionToken() + '-' + ctrl.selectedPage()
        }, [
          m('div', {
            class: stripClass
          }, vnode.children)
        ])
      ]),
      m(`div.ba.bw1${ctrl.selectedPage() == ctrl.numberOfPages() ? '.dn' : '.flex.items-center'}${ctrl.isPaging() ? '.o-50' : ''}`, {
        onclick:function(e){
          if(ctrl.selectedPage()!=ctrl.numberOfPages() && !ctrl.isPaging()){
            ctrl.nextPage();
          }
        }
      }, [
        m('i.ion-ios-arrow-forward.blue.f3.ph1')
      ]),
    ]),

  ])
}

module.exports = cardsPagination;
